module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai2-60273eda793312c64b401818eb19ba61.jpg";